// CPB App Script (all pages)
// v_2026-05-05-1

import { activateMainBannerPreview } from './sections/activate-main-banner-preview.js';
import { flicking } from './sections/flicking.js';
import { partnersFlicking } from './sections/partners-flicking.js';
import { ourFeaturesFlicking } from './sections/our-features-flicking.js';
import { examplesFlicking } from './sections/examples-flicking.js';
import { integrationsPreview } from './sections/integrations-preview.js';
import { testimonialsSection } from './sections/testimonials-section.js';
import { headerSize } from './sections/header-size.js';
import { mainBannerAnimation } from './sections/main-banner-animation.js';
import { scaleMultiplier } from './sections/scale-multiplier.js';
import { contactForm } from './sections/contact-form.js';
import { calendarIframeSize } from './sections/calendar-iframe-size.js';
import { mobileMenu } from './sections/mobile-menu.js';
import { connectQuestionForms } from './sections/connect-questions-form.js';
import { connectSubscribeForms } from './sections/connect-subscribe-forms.js';
import { connectPlatformVoteForm } from './sections/connect-platform-vote-form.js';
import { pickYourPlatformCards } from './sections/pick-your-platform-cards.js';
import { portfolioCarusel } from './sections/portfolio-carusel.js';
import { faqToggle } from './sections/faq-toggle.js';
import { heroOverlapBackground } from './sections/hero-overlap-background.js';
import { reuseHeaderIconInFooter } from './sections/reuse-header-icon-in-footer.js';
import { footerNavigation } from './sections/footer-navigation.js';
import { createTextScrollRevealAnimation } from './sections/create-text-scroll-reveal-animation.js';
import { normalizeDemoCallLinks } from './sections/normalize-demo-call-links.js';
import { headerSubmenu } from './sections/header-submenu.js';
import { viewportHeight } from './sections/viewport-height.js';
import { analytics } from './sections/analytics.js';

import { initCalc } from './calculator/index.js';
import { tabSwitch } from './calculator/tabSwitch.js';

const CPB_SCRIPT_VERSION = '2026-05-05-1';

console.info(`[CPB] Website script v${CPB_SCRIPT_VERSION}`);

runWhenDomReady(initSite);

function runWhenDomReady(callback) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
        return;
    }

    callback();
}

function initSite() {
    [
        ['analytics', analytics],
        ['headerSize', headerSize],
        ['mainBannerAnimation', mainBannerAnimation],
        ['activateMainBannerPreview', activateMainBannerPreview],
        ['flicking', flicking],
        ['partnersFlicking', partnersFlicking],
        ['ourFeaturesFlicking', ourFeaturesFlicking],
        ['examplesFlicking', examplesFlicking],
        ['integrationsPreview', integrationsPreview],
        ['testimonialsSection', testimonialsSection],
        ['scaleMultiplier', scaleMultiplier],
        ['contactForm', contactForm],
        ['mobileMenu', mobileMenu],
        ['connectQuestionForms', connectQuestionForms],
        ['connectSubscribeForms', connectSubscribeForms],
        ['connectPlatformVoteForm', connectPlatformVoteForm],
        ['headerSubmenu', headerSubmenu],
        ['viewportHeight', viewportHeight],
        ['pickYourPlatformCards', pickYourPlatformCards],
        ['portfolioCarusel', portfolioCarusel],
        ['faqToggle', faqToggle],
        ['heroOverlapBackground', heroOverlapBackground],
        ['createTextScrollRevealAnimation', createTextScrollRevealAnimation],
        ['footerNavigation', footerNavigation],
        ['reuseHeaderIconInFooter', reuseHeaderIconInFooter],
        ['normalizeDemoCallLinks', normalizeDemoCallLinks],
        ['initCalculatorPage', initCalculatorPage],
    ].forEach(([name, initializer]) => runInitializer(name, initializer));
}

function runInitializer(name, initializer) {
    try {
        initializer();
    } catch (err) {
        console.error(`[CPB] ${name} init failed`, err);
    }
}

function initCalculatorPage() {
    const plansPrices = document.querySelector('#plans-prices');
    if (!plansPrices || plansPrices.dataset.cpbCalculatorInitialized === 'true') return;

    plansPrices.dataset.cpbCalculatorInitialized = 'true';
    initCalc();
    if (!window.priceCalculator) window.priceCalculator = {};
    window.priceCalculator.changeTab = tabSwitch.changeTab.bind(tabSwitch);
}
